module.exports = __webpack_public_path__ + "img/liveing.a0ab0095.gif";